import styled from 'styled-components';

export const AttachmentsListWrapper = styled.div<{ isInline: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ isInline }) => (isInline ? 'row' : 'column')};
`;
